import { render, staticRenderFns } from "./BlockedUsers.vue?vue&type=template&id=121d5720"
import script from "./BlockedUsers.vue?vue&type=script&lang=ts"
export * from "./BlockedUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports